module.exports = __webpack_public_path__ + "img/paul-pro.34d5ad5f.jpg";